import React, { createContext, useState, useEffect } from 'react';
import api from '../components/api/api';

export const UserSettingsContext = createContext();

export const UserSettingsProvider = ({ children }) => {
    const [userSettings, setUserSettings] = useState(null);
    const [selectableAccounts, setSelectableAccounts] = useState(null);

    const transformUserSettings = (data) => {
        return data.map(item => ({
            setting_id: item.setting.id,
            setting_name: item.setting.setting_name,
            description: item.description
        }));
    };
    
    const fetchUserSettings = async () => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/accounts/api/user-settings/`);
            const settings = response.data;
            const transformedSettings = transformUserSettings(settings);
            setUserSettings(transformedSettings);
        } catch (error) {
            console.error('Error fetching user settings:', error);
        }
    };
    
    const fetchSelectableAccounts = async () => {
        try {
            const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/account-definitions/`);
            setSelectableAccounts(response.data);
        } catch (error) {
            console.error('Error fetching user settings:', error);
        }
    }

    useEffect(() => {
        fetchUserSettings();
        fetchSelectableAccounts();
    }, []);

    // 更新関数
    const addUserSetting = async (newSetting) => {
        try {
            const response = await api.post(`${process.env.REACT_APP_API_URL}/accounts/api/user-settings/`, newSetting);
            fetchUserSettings();
        } catch (error) {
            console.error('Error adding user setting:', error);
        }
    };

    // 削除関数
    const deleteUserSetting = async (settingId, setUserSettings) => {
        try {
            await api.delete(`${process.env.REACT_APP_API_URL}/accounts/api/user-settings/`, {
                data: { setting_id: settingId },
            });
            console.log('User setting deleted successfully');
        } catch (error) {
            console.error('Error deleting user setting:', error);
        }
    };

    return (
        <UserSettingsContext.Provider value={{ userSettings, setUserSettings, addUserSetting, selectableAccounts }}>
            {children}
        </UserSettingsContext.Provider>
    );
};

export const getDescriptionBySettingName = (data, settingsName) => {
    if (data) {
        const foundItem = data.find(item => item.setting_name === settingsName);
        return foundItem ? foundItem.description : null;
    } else {
        return null;
    }
    
};

export const getDescriptionName = (description) => {
    const mapping = {
        "stock_price": "株価",
        "sales": "売上高",
        "net_income": "当期利益",
        "net_income_margin": "当期利益率",
        "per": "PER",
        "roe": "ROE",
        "sales": "売上高",
        "operating_income": "営業利益",
        "ordinary_income": "経常利益",
        "net_income": "当期利益",
        "cash_and_cash_equivalents": "現預金",
        "equity": "自己資本",
        "total_assets": "総資産",
        "operating_cf": "営業活動によるキャッシュフロー",
        "investment_cf": "投資活動によるキャッシュフロー",
        "financial_cf": "財務活動によるキャッシュフロー",
        "equity_ratio": "自己資本比率",
        "current_ratio": "流動比率",
        "fixed_ratio": "固定比率",
    }
    return mapping[description];
};
